export default () => {
  const scriptTagId = 'cf-insights-component'

  if (document.getElementById(scriptTagId) !== null) return

  const scriptTag = document.createElement('script')
  scriptTag.setAttribute('id', scriptTagId)
  scriptTag.setAttribute(
    'src',
    'https://static.cloudflareinsights.com/beacon.min.js'
  )
  scriptTag.setAttribute('data-cf-beacon', `{"token": "${import.meta.env.VITE_CF_INSIGHTS_KEY}"}`)
  scriptTag.setAttribute('defer', '')

  document.body.appendChild(scriptTag)
}
